import { v4 as uuidv4 } from "uuid";

class ReactNativeFile {
  uri: string;
  name: string;
  type: string;
  fileSize?: number;
  externalId: string;
  _id: string;

  constructor({
    uri,
    name,
    type,
    fileSize,
    externalId,
    _id,
  }: {
    uri: string;
    name: string;
    type: string;
    fileSize?: number;
    externalId?: string;
    _id?: string;
  }) {
    this.uri = uri;
    this.name = name;
    this.type = type;
    this.fileSize = fileSize;
    this.externalId = externalId || "";
    this._id = _id || uuidv4();
  }

  setExternalId(externalId: string) {
    this.externalId = externalId;
  }
}

export default ReactNativeFile;
